import { render, staticRenderFns } from "./WithdrawTable.vue?vue&type=template&id=fbb59bd4&scoped=true&"
import script from "./WithdrawTable.vue?vue&type=script&lang=js&"
export * from "./WithdrawTable.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawTable.vue?vue&type=style&index=0&id=fbb59bd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb59bd4",
  null
  
)

export default component.exports